export default {
  AID: '',
  CUR: '',
  balance: 0,
  dataSourceId: null,
  shortcut: 6,
  startDate: '',
  endDate: '',
  rebatesList: [],
  approvedTime: 0,
  ibReportSelectedTab: 'funding',
}
